import Vue from 'vue';
import Router from 'vue-router';



const requireAuth = async (to, from, next) => {

  const user_id = localStorage.getItem('api_token');
  
  //let oh = false;
  if (user_id) {
    next();
  } else {
    next('/login');
  }
};

const routes = [];
routes.push({ path: '/login', component: () => import('./pages/Login.vue') });
routes.push({ path: '/', redirect: '/login', beforeEnter: requireAuth });
// routes.push({ path: '/home', component: () => import('./pages/Home.vue'), beforeEnter: requireAuth });
const level = localStorage.getItem("user_level");
if (level == 1) {
  routes.push({ path: '/home', component: () => import('./pages/Home.vue'), beforeEnter: requireAuth });
  routes.push({ path: '/sales_orders', component: () => import('./pages/sales_orders/List.vue'), beforeEnter: requireAuth });
  routes.push({ path: '/print/:id', component: () => import('./pages/sales_orders/Print.vue'), beforeEnter: requireAuth });
  routes.push({ path: '/customers', component: () => import('./pages/clients/List.vue'), beforeEnter: requireAuth });
  routes.push({ path: '/products/plates', component: () => import('./pages/products/ListPlates.vue'), beforeEnter: requireAuth });
  routes.push({ path: '/products/drinks', component: () => import('./pages/products/ListDrinks.vue'), beforeEnter: requireAuth });
  routes.push({ path: '/products/dessert', component: () => import('./pages/products/ListDessert.vue'), beforeEnter: requireAuth });
  routes.push({ path: '/type_payments', component: () => import('./pages/type_payments/List.vue'), beforeEnter: requireAuth });
  routes.push({ path: '/settings', component: () => import('./pages/Settings.vue'), beforeEnter: requireAuth });
  routes.push({ path: '/users', component: () => import('./pages/users/List.vue'), beforeEnter: requireAuth });
}

if (level == 2) {
  routes.push({ path: '/home', component: () => import('./pages/Home.vue'), beforeEnter: requireAuth });
  routes.push({ path: '/sales_orders', component: () => import('./pages/sales_orders/List.vue'), beforeEnter: requireAuth });
  routes.push({ path: '/print/:id', component: () => import('./pages/sales_orders/Print.vue'), beforeEnter: requireAuth });
  routes.push({ path: '/customers', component: () => import('./pages/clients/List.vue'), beforeEnter: requireAuth });
}


if (level == 3) {
  //routes.push({ path: '/home', redirect: '/Kitchen', beforeEnter: requireAuth });
  routes.push({ path: '/home', component: () => import('./pages/sales_orders/Kitchen.vue'), beforeEnter: requireAuth });
}



Vue.use(Router);
export default new Router({
  mode: 'history',
  routes
});
